import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError } from '@angular/router';
import { WebSocketService } from 'polly-commons';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy{
  public title: string = 'polly-manage';
  public isLoading: boolean = true;
  private readonly subsink = new SubSink();

  constructor(
    private readonly websocketService: WebSocketService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.subsink.sink = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isLoading = false;
      }
    });
  }

  public ngOnDestroy(): void {
    this.websocketService.closeConnection();
    this.subsink.unsubscribe();
  }
}
